import { translateText } from "../../../helpers/LanguageHelper";
import React from 'react';
import { Helmet } from 'react-helmet';
import Config from '../../../helpers/Config';
import DiscountBannerOmg from '../../components/shared/DiscountBannerOmg';
import NewProducts from '../../components/products/NewProducts';
import CompaignSection from '../../components/shared/CompaignSection';
import TodayHotDeal from '../../components/products/TodayHotDeal';
import CustomerTestimonial from '../../components/shared/CustomerTestimonial';
import PopularProducts from '../../components/products/PopularProducts';
import ContactBanner from '../../components/shared/ContactBanner';
import WhatsAppFloat from '../../components/shared/WhatsAppFloat';

const Home = () => {
    const siteTitle = Config['SITE_TTILE'];

    return (
        <>
            <WhatsAppFloat />
            <Helmet>
                <title>{translateText("Buy Uthukuli Butter Online from Uthukuli")}{siteTitle}{translateText(" - Home")}</title>
                <meta name="description" content="Buy Uthukuli butter online from Uthukuli. We provide 100% pure white butter made from cow and buffalo milk cream." />
                <meta name="robots" content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large" />
                <meta property="og:title" content="Buy Authentic Uthukuli Butter Online from Uthukuli – UKLButter" />
                <meta property="og:description" content="Taste the purity of traditional Uthukuli Butter. Freshly churned and delivered across India." />
                <meta property="og:site_name" content="UKLButter.com" />
                <meta name="keywords" content="UKLButter, Uthukuli butter, pure butter India, homemade butter, cow butter, natural butter online" />
            </Helmet>

            <main className="ukl-home">
                <section className="ukl-curated ukl-curated--first">
                    <NewProducts effect="icon-inline" />
                </section>
                <DiscountBannerOmg />
                <CompaignSection />
                <TodayHotDeal />
                <CustomerTestimonial />
                <PopularProducts hoverEffect="icon-inline" />
                <ContactBanner />
            </main>
        </>
    );
};

export default Home;
